<script lang="ts">
  import Datepicker from 'vanillajs-datepicker/Datepicker';
  import 'vanillajs-datepicker/css/datepicker.css';
  import { onMount } from 'svelte';
  import type { HTMLInputAttributes } from 'svelte/elements';
  import { formatDateShort } from '$lib/util';

  interface AdditionalProps {
    minDate?: string;
    invalid?: boolean;
  }

  let { value = $bindable(), minDate, invalid = false, ...props }: HTMLInputAttributes & AdditionalProps = $props();

  let element: HTMLInputElement;
  let datepicker: Datepicker | null = $state(null);

  onMount(() => {
    if (!props.readonly) {
      datepicker = new Datepicker(element, {
        buttonClass: 'btn datepicker-btn',
        minDate: minDate,
        format: 'mm/dd/yyyy',
      });

      element.addEventListener('changeDate', e => {
        value = formatDateShort((e as CustomEvent).detail.date);
      });
    }
  });

  $effect(() => {
    if (!props.readonly) {
      datepicker!.setOptions({ minDate });
    }
  });
</script>

<input
  bind:this={element}
  type="text"
  class="form-control"
  class:is-invalid={invalid}
  aria-invalid={invalid ? 'true' : 'false'}
  onclick={() => {
    if (!props.readonly) {
      datepicker!.show();
    }
  }}
  {value}
  {...props}
/>
